module.exports = __webpack_public_path__ + "img/164.d3490fd2.jpg";